import TimeoutTrigger from './TimeoutTrigger';

export default class ImmediatelyTrigger extends TimeoutTrigger {

    static TRIGGER_NAME = 'immediately';

    timeout = 0;
}
